export function profile_menu_expand()
{
    if( document.querySelector(".majixel_profile .profile_menu")!==null && document.querySelector(".majixel_profile .profile_menu")!==undefined ){
        let $expand_button = document.querySelector(".majixel_profile .profile_menu .menu_items.expand_menu li");
        let $menu_profile = document.querySelector(".majixel_profile .profile_menu");
        let $content_profile = document.querySelector(".majixel_profile .profile_content");
        let $overlay_layout = document.querySelector(".majixel_profile .profile_content .majixel_profile_overlay_bg");
        if( Number( window.innerWidth ) >= 618 )
        {
            if( ! $menu_profile.classList.contains("expanded_in_lg") )
            {
                $menu_profile.classList.add("expanded_in_lg");
                $content_profile.classList.add("expanded_menu_in_lg");
                $menu_profile.classList.remove("expand");
                if( ! $menu_profile.classList.contains("expand") ){
                    $menu_profile.classList.add("expand");
                }
                $expand_button.querySelector("span").classList.remove("fa-arrow-alt-circle-left");
                $expand_button.querySelector("span").classList.add("fa-arrow-alt-circle-right");
            }
        }else{
            if( $menu_profile.classList.contains("expanded_in_lg") )
            {
                $menu_profile.classList.remove("expanded_in_lg");
                $content_profile.classList.remove("expanded_menu_in_lg");
                if( $menu_profile.classList.contains("expand") ){
                    $menu_profile.classList.remove("expand");
                }
                $expand_button.querySelector("span").classList.remove("fa-arrow-alt-circle-right");
                $expand_button.querySelector("span").classList.add("fa-arrow-alt-circle-left");
            }
        }
        $expand_button.addEventListener( 'click', ev=> {
            ev.preventDefault();
            if( $menu_profile.classList.contains("expand") )
            {
                $menu_profile.classList.remove("expand");
                $expand_button.querySelector("span").classList.remove("fa-arrow-alt-circle-right");
                $expand_button.querySelector("span").classList.add("fa-arrow-alt-circle-left");
                if( $content_profile.classList.contains("expand_menu") )
                {
                    $content_profile.classList.remove("expand_menu");
                }
                if( $overlay_layout.classList.contains("show") )
                {
                    $overlay_layout.classList.remove("show");
                }
                if( $menu_profile.classList.contains("expanded_in_lg") )
                {
                    $menu_profile.classList.remove("expanded_in_lg");
                }
                if( $content_profile.classList.contains("expanded_menu_in_lg") )
                {
                    $content_profile.classList.remove("expanded_menu_in_lg");
                }
            }else{
                $menu_profile.classList.add("expand");
                $expand_button.querySelector("span").classList.remove("fa-arrow-alt-circle-left");
                $expand_button.querySelector("span").classList.add("fa-arrow-alt-circle-right");
                $content_profile.classList.add("expand_menu");
                $overlay_layout.classList.add("show");
            }
        } );
        $overlay_layout.addEventListener( 'click', ev=> {
            ev.preventDefault();
            if( $menu_profile.classList.contains("expand") )
            {
                $menu_profile.classList.remove("expand");
                $expand_button.querySelector("span").classList.remove("fa-arrow-alt-circle-right");
                $expand_button.querySelector("span").classList.add("fa-arrow-alt-circle-left");
                $content_profile.classList.remove("expand_menu");
                $overlay_layout.classList.remove("show");
            }
        });
    }
}